export function formatAddress(address) {
  return {
    address1: address.address1,
    address2: address.address2,
    city: address.city,
    state: address.state,
    zipcode: address.zipCode || address.zipcode,
  };
}
